import HTML5Backend from 'react-dnd-html5-backend-cjs';

export const ModifiedBackend = (...args) => {
    const instance = new HTML5Backend(...args);
    const shouldIgnoreTarget = target => {
        return target && target.classList && (target.classList.contains('ignore-html5-dnd') || target.classList.contains('rbc-day-bg') || target.classList.contains('rbc-event') || target.classList.contains('rbc-time-slot'));
    }
    
    const listeners = [
        'handleTopDragStart',
        'handleTopDragStartCapture',
        'handleTopDragEndCapture',
        'handleTopDragEnter',
        'handleTopDragEnterCapture',
        'handleTopDragLeaveCapture',
        'handleTopDragOver',
        'handleTopDragOverCapture',
        'handleTopDrop',
        'handleTopDropCapture'
    ];

    listeners.forEach(name => {
        const original = instance[name];
        instance[name] = (e, ...extraArgs) => {
            if (!shouldIgnoreTarget(e.target)) {
                original(e, ...extraArgs);
            }
        };
    });

    return instance;
};
